import { Component, OnInit } from '@angular/core';
import { SecurityService } from '../security.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DialogWithCloseButtonComponent } from '../../utils/dialog-with-close-button/dialog-with-close-button.component';
import { DataService } from 'src/app/shared/data.service';
import { CustomerProfile } from '../../security/models/customer-profile.model';
import { Addr } from 'src/app/shared/model/addr.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false
})
export class LoginComponent implements OnInit {

  buttonSelected: string = "Login";
  authToken: string;
  user = {
    'loginId': '',
    'password': ''
  }
  custProfile = new CustomerProfile();

  popMsg = {
    'title': '',
    'message': ''
  }


  constructor(
    public dataSvc: DataService,
    private authSvc: SecurityService,
    private router: Router,
    public dialog: MatDialog) { }

  ngOnInit(): void {
    //if(environment.production){
    if (!!localStorage.getItem('AuthToken')) {
      localStorage.removeItem('AuthToken');
      localStorage.removeItem('User');
      this.dataSvc.clearData();
      this.authSvc.updateLoginStatus();
      this.router.navigate(['/home']);
    }
    //}
  }

  login() {
    if (!this.isFormComplete()) return;
    this.authSvc.authenticateUser(this.user).subscribe(
      res => {
        console.log("Auth toekn received : " + res.jwt);

        localStorage.setItem("AuthToken", res.jwt);
        localStorage.setItem("User", this.user.loginId);

        // Notify subscribers immediately that user is logged in
        this.authSvc.updateLoginStatus();

        if (this.user.loginId === 'ksolve-admin') {
          console.log("Login Success: KSolve Admin logged in. Skipping profile fetch.");
          this.router.navigate(['/reception']);
          return;
        }

        this.authSvc.getCustomerProfileByLoginId(this.user.loginId).subscribe(
          res => {
            console.log("Login Success, profile:" + JSON.stringify(res));
            this.custProfile = JSON.parse(JSON.stringify(res));

            if (this.custProfile.homeOrOfficeAddress == null) {
              this.custProfile.homeOrOfficeAddress = new Addr();
            }
            if (this.custProfile.mailingOrShippingAddress == null) {
              this.custProfile.mailingOrShippingAddress = new Addr();
            }

            console.log("Login Success, Cust Profile:" + JSON.stringify(this.custProfile));


            this.dataSvc.setCustomerProfile(this.custProfile);
            this.authSvc.updateLoginStatus();
          },
          err => console.log("Login error: " + err)
        );

        this.router.navigate(['/reception']);

      },
      err => {
        this.popMsg.title = "Login failed";
        this.popMsg.message = "Login failed, please try again"
        console.log(err)
        this.openDialog(this.popMsg);

      }
    )
  }

  register() {
    this.router.navigate(['/register']);
  }

  forgotPassword() {
    let data = { 'pageTitle': 'Forgot Password', 'navigateTo': '/login' };
    this.dataSvc.setSharedData(data);
    this.router.navigate(['/forgot-password']);
  }

  openDialog(popupMessage) {
    this.dialog.open(DialogWithCloseButtonComponent, { data: popupMessage });
  }

  isFormComplete(): boolean {
    if (this.user.loginId === '') {
      this.popMsg.title = 'Email is required';
      this.popMsg.message = 'Please enter the email address';

      this.openDialog(this.popMsg);
      return false;
    }

    if (this.user.password === '') {
      this.popMsg.title = 'Password is required';
      this.popMsg.message = 'Please enter the password';

      this.openDialog(this.popMsg);
      return false;
    }

    return true;
  }


  cancel() {
    this.user = {
      'loginId': '',
      'password': ''
    }
  }
}
